// extracted by mini-css-extract-plugin
export default {"PropertiesList":"PropertiesListScreen_PropertiesList__K8ZWa"};